import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e89ff062&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e89ff062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89ff062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e89ff062')) {
      api.createRecord('e89ff062', component.options)
    } else {
      api.reload('e89ff062', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e89ff062&scoped=true&", function () {
      api.rerender('e89ff062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sdGy5OYha0fb/JS/comp/GuestBox.vue"
export default component.exports